module.exports = __webpack_public_path__ + "img/agency-promo.9ce5201c.svg";